import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import type { Asset } from '@/types';
import exodus from '@/ui/exodus';
import type { Sorting } from '@/ui/flux/fiat-balances/selectors/create-sorted-assets-selector-factory';
import createSortedEnabledAssetsSelector from '@/ui/flux/fiat-balances/selectors/create-sorted-enabled-assets';

const SORTING = [
  ['fiatBalance', 'desc'],
  ['displayName', 'asc'],
] satisfies Sorting;

// TODO: Remove in favor of @exodus/exchange-ui
const useAvailableFromAssets = (
  makeRequest = true,
): { value: Asset[]; loading: boolean } => {
  const [loading, setLoading] = useState(true);
  const [availableFromAssets, setAvailableFromAssets] = useState<Asset[]>([]);

  const sortedAssets = useSelector(createSortedEnabledAssetsSelector(SORTING));

  useEffect(() => {
    if (!makeRequest) {
      return;
    }
    setLoading(true);

    exodus.exchange.getSupportedFromAssetIds().then((fetchedAssets) => {
      setAvailableFromAssets(
        sortedAssets.filter((asset) => fetchedAssets.includes(asset.ticker)),
      );
      setLoading(false);
    });
  }, [makeRequest, sortedAssets]);

  return { value: availableFromAssets, loading };
};

export default useAvailableFromAssets;
